module.exports = __webpack_public_path__ + "media/images/textSelectionSample__dropdown@2x-188304ca8bda872bf8bbc9de00fc3d8e.png";